import { render, staticRenderFns } from "./Feyi.vue?vue&type=template&id=6ae324d2&scoped=true&"
import script from "./Feyi.vue?vue&type=script&lang=js&"
export * from "./Feyi.vue?vue&type=script&lang=js&"
import style0 from "./Feyi.vue?vue&type=style&index=0&id=6ae324d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae324d2",
  null
  
)

export default component.exports